import React, { useMemo } from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'

import {
  SurveyReportPatientScore,
  SurveyReportScoringRanges
} from '../../../api/services/user_assignment_codes/types.ts'
import {
  setSurveyReportTableActions,
  setSurveyReportTableColumns
} from '../../../utils/assignmentCodes/surveyReportTableSettings.tsx'
import Alert from '../../common/Alert/Alert.tsx'
import Table from '../../common/Table/Table.tsx'

const SurveyReportTable = ({
  surveyReport,
  scoringRanges
}: {
  surveyReport: SurveyReportPatientScore[]
  scoringRanges: SurveyReportScoringRanges[]
}) => {
const navigate = useNavigate()
  const columns = useMemo(() => setSurveyReportTableColumns(scoringRanges), [scoringRanges])
  const actions = useMemo(
    () => setSurveyReportTableActions(navigate),
    [navigate]
  )

  return (
    <div className="mb-6 border-gray-200 pt-1 dark:border-gray-700">
      {surveyReport.length > 0 && (
        <Table columns={columns} data={surveyReport} actions={actions} />
      )}
      {surveyReport.length === 0 && (
        <div>
          <Alert
            type="info"
            message="Brak danych"
            icon={<AiOutlineInfoCircle className="text-lg" />}
          />
        </div>
      )}
    </div>
  )
}
export default React.memo(SurveyReportTable)
